module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAABHNCSVQICAgIfAhkiAAAAMdJREFUOI29lE0SgjAMRl8YDxTRveVk9WaUPUhOZNxUFHAci45v1WmTTH6+FH6E3A+qx1DqbNandaD9wYH0wv4dAZfGrE+76cqlQby1cZA3jjNU64gQgVQt0kxlJVYdEACqxUt4rruEqTTVOlLco+sJ5wy52arHgHi7IZFk49Bs8PsDc0GKR/IUSrBxkIeOxCPuyezycc26PzguzfqyANU65kkDWUdZhKkkEFQdImEWKIswbFjcyX7Z7LYws0DW0mpBv/1OvuYGb4FLI5fyHaAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/TjianliZhiye.png
// module id = M+1y
// module chunks = 1